import React, { useRef, useMemo } from 'react';
import { IncognitoIcon } from '@cmp-src/@v2/icons';
import { ImpersonateWidget } from '@webV2/components/impersonation/ImpersonateWidget';
import { Button } from '@v2/components/ui/button';
import { Circle } from 'lucide-react';
import { cn } from '@v2/lib/utils';
import { roundButtonClassNames } from './MainSidebar';
import { useImpersonateContext } from '@webV2/providers/ImpersonateProvider';

export const ImpersonationButton: React.FC = () => {
  const {
    isSidebarButtonEnabled,
    isWidgetVisible,
    toggleWidget,
    isBeingImpersonated,
    canImpersonate,
    setIsWidgetVisible
  } = useImpersonateContext();

  const impersonateButtonRef = useRef<HTMLButtonElement>(null);

  const isShowingImpersonationButton = useMemo(
    () => (canImpersonate || isBeingImpersonated) && isSidebarButtonEnabled,
    [canImpersonate, isBeingImpersonated, isSidebarButtonEnabled]
  );

  if (!isShowingImpersonationButton) {
    return null;
  }

  return (
    <div>
      <div className="relative">
        {isBeingImpersonated && (
          <div className='pointer-events-none absolute inset-0 z-0'>
            <Circle className="h-full w-full animate-ping text-red-500/50" />
          </div>
        )}
        <Button
          ref={impersonateButtonRef}
          size="icon"
          variant="secondary"
          className={cn(
            roundButtonClassNames,
            'relative z-10 p-0',
            isBeingImpersonated &&
              'bg-red-500 text-white hover:bg-red-600 hover:text-white hover:ring-red-600'
          )}
          onClick={toggleWidget}
        >
          <IncognitoIcon
            className={cn('size-[20px]', isBeingImpersonated && 'text-white')}
          />
        </Button>
      </div>

      <ImpersonateWidget
        triggerRef={impersonateButtonRef}
        isVisible={isWidgetVisible}
        onClose={() => setIsWidgetVisible(false)}
      />
    </div>
  );
};
